import React, { useState } from 'react';
import { ThumbsUp, Flag, CheckCircle } from 'lucide-react';
import { StarRating } from './StarRating';
interface ReviewCardProps {
  id: string;
  userName: string;
  userInitials: string;
  rating: number;
  date: string;
  verifiedTransaction: boolean;
  reviewText: string;
  sellerResponse?: {
    text: string;
    date: string;
  };
  helpful: number;
  onHelpful?: () => void;
  onReport?: () => void;
}
export function ReviewCard({
  id,
  userName,
  userInitials,
  rating,
  date,
  verifiedTransaction,
  reviewText,
  sellerResponse,
  helpful,
  onHelpful,
  onReport
}: ReviewCardProps) {
  const [hasVotedHelpful, setHasVotedHelpful] = useState(false);
  const handleHelpful = () => {
    if (!hasVotedHelpful && onHelpful) {
      setHasVotedHelpful(true);
      onHelpful();
    }
  };
  return <div data-testid="review-card" data-review-id={id} className="border border-gray-300 bg-white p-6" data-id="element-1018">
      <div className="flex items-start justify-between mb-4" data-id="element-1019">
        <div className="flex items-start gap-3" data-id="element-1020">
          <div data-testid="review-card-avatar" className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center font-bold text-sm" data-id="element-1021">
            {userInitials}
          </div>
          <div data-id="element-1022">
            <div className="flex items-center gap-2 mb-1" data-id="element-1023">
              <span data-testid="review-card-username" className="font-bold text-sm" data-id="element-1024">
                {userName}
              </span>
              {verifiedTransaction && <span data-testid="review-card-verified-badge" className="flex items-center gap-1 text-xs text-green-600 bg-green-50 px-2 py-0.5 border border-green-200" data-id="element-1025">
                  <CheckCircle className="w-3 h-3" data-id="element-1026" />
                  Verified Purchase
                </span>}
            </div>
            <StarRating rating={rating} size="sm" showNumber={false} data-id="element-1027" />
          </div>
        </div>
        <span data-testid="review-card-date" className="text-xs text-gray-500 font-mono" data-id="element-1028">
          {date}
        </span>
      </div>

      <p data-testid="review-card-text" className="text-sm text-gray-700 leading-relaxed mb-4" data-id="element-1029">
        {reviewText}
      </p>

      {sellerResponse && <div data-testid="review-card-seller-response" className="mt-4 pl-4 border-l-2 border-gray-200 bg-gray-50 p-4" data-id="element-1030">
          <div className="flex items-center gap-2 mb-2" data-id="element-1031">
            <span className="text-xs font-bold text-gray-700" data-id="element-1032">
              Seller Response
            </span>
            <span data-testid="review-card-seller-response-date" className="text-xs text-gray-500 font-mono" data-id="element-1033">
              {sellerResponse.date}
            </span>
          </div>
          <p data-testid="review-card-seller-response-text" className="text-sm text-gray-600" data-id="element-1034">
            {sellerResponse.text}
          </p>
        </div>}

      <div data-testid="review-card-actions" className="flex items-center gap-4 mt-4 pt-4 border-t border-gray-200" data-id="element-1035">
        <button data-testid="review-card-helpful-btn" data-voted={hasVotedHelpful} onClick={handleHelpful} disabled={hasVotedHelpful} className={`flex items-center gap-2 text-xs ${hasVotedHelpful ? 'text-blue-600 font-bold' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1036">
          <ThumbsUp className="w-3 h-3" data-id="element-1037" />
          Helpful ({helpful + (hasVotedHelpful ? 1 : 0)})
        </button>
        <button data-testid="review-card-report-btn" onClick={onReport} className="flex items-center gap-2 text-xs text-gray-500 hover:text-red-600" data-id="element-1038">
          <Flag className="w-3 h-3" data-id="element-1039" />
          Report
        </button>
      </div>
    </div>;
}